// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-font {
  margin-bottom: 0px;
  padding-left: 10px;
  color: #6e6e6e;
}

.small-font {
  margin-bottom: 0px;
  font-size: 12px;
  padding-left: 10px;
}

.mail-row {
  margin-bottom: 5px;
  box-shadow: 0 4px 3px 0 rgba(0, 0, 0, 0.01), 0 1px 5px 0 rgba(0, 0, 0, 0.13);
  cursor: pointer;
  padding-bottom: 5px;
  padding-top: 5px;
  width: calc(100% + 15px);
}

.selected {
  background: #4c6a82;
  color: #fff !important;
}

.selected > .heading-font {
  color: #fff !important;
}

.mb-0 {
  margin-bottom: 0px;
}

.small-text {
  font-size: 15px;
  font-weight: bold;
}

.attachment {
  position: absolute;
  right: 11px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/correspondence/correspondence.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AACA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,4EAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;AAGJ;;AADA;EACI,mBAAA;EACA,sBAAA;AAIJ;;AAFA;EACI,sBAAA;AAKJ;;AAHA;EACI,kBAAA;AAMJ;;AAJA;EACI,eAAA;EACA,iBAAA;AAOJ;;AALA;EACI,kBAAA;EACA,WAAA;AAQJ","sourcesContent":[".heading-font{\r\n    margin-bottom: 0px;    \r\n    padding-left: 10px;\r\n    color: #6e6e6e;\r\n}\r\n.small-font{\r\n    margin-bottom: 0px;\r\n    font-size: 12px;\r\n    padding-left: 10px;\r\n}\r\n.mail-row{\r\n    margin-bottom: 5px;\r\n    box-shadow: 0 4px 3px 0 rgba(0, 0, 0, 0.01), 0 1px 5px 0 rgba(0, 0, 0, 0.13);\r\n    cursor: pointer;\r\n    padding-bottom: 5px;\r\n    padding-top: 5px;\r\n    width: calc(100% + 15px);\r\n}\r\n.selected {\r\n    background: #4c6a82;\r\n    color: #fff !important;\r\n}\r\n.selected > .heading-font{\r\n    color: #fff !important;\r\n}\r\n.mb-0{\r\n    margin-bottom : 0px;\r\n}\r\n.small-text{\r\n    font-size:15px;\r\n    font-weight:bold;\r\n}\r\n.attachment{\r\n    position: absolute;\r\n    right: 11px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
